var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3158 15.1591L12.2681 12.1113M12.2681 12.1113C12.7894 11.59 13.2029 10.9711 13.4851 10.29C13.7672 9.60883 13.9124 8.87879 13.9124 8.14152C13.9124 7.40426 13.7672 6.67421 13.4851 5.99307C13.2029 5.31193 12.7894 4.69302 12.2681 4.1717C11.7468 3.65037 11.1279 3.23684 10.4467 2.9547C9.76557 2.67256 9.03552 2.52734 8.29826 2.52734C7.561 2.52734 6.83095 2.67256 6.14981 2.9547C5.46866 3.23684 4.84976 3.65037 4.32844 4.1717C3.27557 5.22456 2.68408 6.65255 2.68408 8.14152C2.68408 9.63049 3.27557 11.0585 4.32844 12.1113C5.3813 13.1642 6.80929 13.7557 8.29826 13.7557C9.78723 13.7557 11.2152 13.1642 12.2681 12.1113Z",
    stroke: "#031316",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8bddd49c8aa5fdef2f37de8da39e7c02.svg";
export { ForwardRef as ReactComponent };